import { ViewLarge, Viewport, ViewSmall } from "bernie-view";
import { inject, observer } from "mobx-react";
import * as React from "react";
import { DefaultLocationProps } from "src/components/shared/Location/typings";
import { GroundTransportationLocationState } from "src/stores/wizard/state/car/GroundTransportationLocationState";
import { ACTION_DONE, getTracker } from "src/utils/TrackingUtils";
import { UitkLayoutConditionalGridSpan, UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { TypeaheadSelection } from "uitk-react-typeahead";
import { GroundTransportLocationField } from "./GroundTransportLocationField";
import { GroundTransportSwitch } from "./GroundTransportSwitch";

interface GroundTransportationLocationProps extends DefaultLocationProps {
  groundTransportationLocationState: GroundTransportationLocationState;
  showGTOnly?: boolean;
}

export const GroundTransportLocation: React.FunctionComponent<GroundTransportationLocationProps> = inject(
  "context",
  "analytics"
)(
  observer(
    ({ context, groundTransportationLocationState, colSpan, setInputsRefs, lobState, analytics, showGTOnly }) => {
      if (!context) {
        // Check for injected stores
        return null;
      }

      const {
        originConfig,
        location,
        originInvalidKey,
        destinationConfig,
        destinationInvalidKey,
      } = groundTransportationLocationState;

      const onOriginLocationFieldUpdate = (selection: TypeaheadSelection) => {
        groundTransportationLocationState.updateOriginSelection(selection);
        tracker.trackEvent(originRfrr + ACTION_DONE);
      };

      const onDestinationLocationFieldUpdate = (selection: TypeaheadSelection) => {
        groundTransportationLocationState.updateDestinationSelection(selection);
        tracker.trackEvent(destinationRfrr + ACTION_DONE);
      };

      const onSwapTypeaheadLocations = () => {
        groundTransportationLocationState.swapTypeaheadLocations();
      };

      const originRfrr = "origin.";
      const destinationRfrr = "destination.";

      const track = (event: string) => {
        tracker.trackEvent(event);
      };

      const tracker = getTracker(lobState.trackingEnabled, analytics, lobState.moduleName);
      const locationFieldColSpan: UitkLayoutConditionalGridSpan = { medium: 6 };
      const smallViewColSpan: UitkLayoutConditionalGridSpan = { small: "all" };
      const numberOfColumns = 12;

      return (
        <UitkLayoutGridItem colSpan={colSpan}>
          <div className="GroundTransportationLocation">
            <UitkLayoutGrid columns={numberOfColumns} space="two">
              <Viewport>
                <ViewSmall>
                  <>
                    <GroundTransportLocationField
                      context={context}
                      fieldConfig={originConfig!}
                      fieldInvalidKey={originInvalidKey}
                      location={location.origin}
                      onLocationFieldUpdate={onOriginLocationFieldUpdate}
                      setInputsRefs={setInputsRefs}
                      track={track}
                      trackId={originRfrr}
                      colSpan={smallViewColSpan}
                      groundTransportLocationState={groundTransportationLocationState}
                    />
                    <GroundTransportSwitch onSwapTypeheadLocations={onSwapTypeaheadLocations} showGTOnly={showGTOnly} />
                    <GroundTransportLocationField
                      context={context}
                      fieldConfig={destinationConfig!}
                      fieldInvalidKey={destinationInvalidKey}
                      location={location.destination}
                      onLocationFieldUpdate={onDestinationLocationFieldUpdate}
                      setInputsRefs={setInputsRefs}
                      track={track}
                      trackId={destinationRfrr}
                      colSpan={smallViewColSpan}
                      groundTransportLocationState={groundTransportationLocationState}
                    />
                  </>
                </ViewSmall>
                <ViewLarge>
                  <>
                    <GroundTransportLocationField
                      context={context}
                      fieldConfig={originConfig!}
                      fieldInvalidKey={originInvalidKey}
                      location={location.origin}
                      onLocationFieldUpdate={onOriginLocationFieldUpdate}
                      setInputsRefs={setInputsRefs}
                      track={track}
                      trackId={originRfrr}
                      colSpan={locationFieldColSpan}
                      groundTransportLocationState={groundTransportationLocationState}
                    />
                    <GroundTransportSwitch onSwapTypeheadLocations={onSwapTypeaheadLocations} showGTOnly={showGTOnly} />
                    <GroundTransportLocationField
                      context={context}
                      fieldConfig={destinationConfig!}
                      fieldInvalidKey={destinationInvalidKey}
                      location={location.destination}
                      onLocationFieldUpdate={onDestinationLocationFieldUpdate}
                      setInputsRefs={setInputsRefs}
                      track={track}
                      trackId={destinationRfrr}
                      colSpan={locationFieldColSpan}
                      groundTransportLocationState={groundTransportationLocationState}
                    />
                  </>
                </ViewLarge>
              </Viewport>
            </UitkLayoutGrid>
          </div>
        </UitkLayoutGridItem>
      );
    }
  )
);
